import swiperWidget from './swiperWidget';

export default function () {
  const widgetName = 'vimeoWidget';
  const widgetOpts = vimeoWidgetOpts;

  function addClass(slide) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let vimeoURLAttr = $(slide.items[x].Description).find('iframe').attr('src');
      vimeoURLAttr = `${vimeoURLAttr}&background=1`;
      $(this).find('.card-widget-description iframe').attr('src', vimeoURLAttr);
      $(this).find('.card-widget-title').remove();
      $(this).find('.buttonwrap').remove();
    });
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (slide) {
      let videoActive = slide.items.length;
      console.log(videoActive);
      if (videoActive < 1) {
        $(`#${widgetName}`).remove();
        swiperWidget();
      } else {
        addClass(slide);
      }
    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'More',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
